<template>
  <CSidebar fixed :minimize="minimize" :show="show" @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
    <CSidebarBrand class="d-md-down-none" to="/">
      <!-- <img class="c-sidebar-brand-full img-fluid m-4" src="/img/logo.svg" /> -->
      <h1 class="c-sidebar-brand-full img-fluid m-4">Atdatasos</h1>
      <font-awesome-icon icon="cog" class="c-sidebar-brand-minimized" />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="menu" />
    <CSidebarMinimizer class="d-md-down-none" @click.native="$store.commit('set', ['sidebarMinimize', !minimize])" />
  </CSidebar>
</template>

<script>
import nav from "./_nav";

export default {
  name: "TheSidebar",
  data: () => ({
    nav: nav,
  }),
  computed: {
    show() {
      return this.$store.state.sidebarShow;
    },
    minimize() {
      return this.$store.state.sidebarMinimize;
    },
    menu() {
      let _role = parseInt(this.$store.state.authorizationRole);
      let nav = [...this.nav[0]._children];
      let result = [
        {
          _name: "CSidebarNav",
          _children: nav.filter((p) => p.role.indexOf(_role) >= 0),
        },
      ];
      return result;
    },
  },
  mounted() {},
};
</script>
